/** API enums for Cabana flows */

export const CabanaSourceType = {
	MANUAL: "MANUAL",
	SEVENROOMS: "SEVENROOMS",
} as const;

export type CabanaSourceType =
	(typeof CabanaSourceType)[keyof typeof CabanaSourceType];

export const CabanaVenueStatus = {
	DRAFT: "DRAFT",
	PUBLISHED: "PUBLISHED",
	INACTIVE: "INACTIVE",
} as const;

export type CabanaVenueStatus =
	(typeof CabanaVenueStatus)[keyof typeof CabanaVenueStatus];

/** GET /cabanas `sortBy` query enum */
export const CabanaSortBy = {
	DEFAULT: "DEFAULT",
	NAME: "NAME",
	PROPERTY_NAME: "PROPERTY_NAME",
	SOURCE: "SOURCE",
	STATUS: "STATUS",
	UPDATED_AT: "UPDATED_AT",
} as const;

export type CabanaSortBy = (typeof CabanaSortBy)[keyof typeof CabanaSortBy];

export interface CabanaFaqPayload {
	question: string;
	answer: string;
}

export interface CabanaUpsertPayload {
	name: string;
	propertyId: string;
	phoneNo?: string;
	status: CabanaVenueStatus;
	address?: string;
	googleLocation?: string;
	description?: string;
	restaurantName?: string;
	bannerImage?: string;
	media?: string[];
	faqs?: CabanaFaqPayload[];
}
